/**
 * Whether the user has requested reduced motion (WCAG 2.3.3).
 *
 * For JS-driven motion (canvas-confetti, driver.js) that CSS cannot neutralise.
 * Purely declarative CSS animations/transitions are handled globally in
 * `src/theme/globalCss.ts`. SSR-safe: returns `false` when `window`/`matchMedia`
 * is unavailable.
 */
export function prefersReducedMotion(): boolean {
  if (
    typeof window === 'undefined' ||
    typeof window.matchMedia !== 'function'
  ) {
    return false
  }
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
